import { useState } from 'react';
import type { ReactNode } from 'react';
import { Popconfirm, Tag } from 'antd';

/**
 * The antd preset colours of the ad-hoc labels, in one place. "Passport needed"
 * is purple in the lists and geekblue on the details screens, as ShareJet
 * bookings have shown it since SHAR-451/453; charter bookings (SHAR-1027) use
 * the same two.
 */
export const ADHOC_COLORS = {
  awaitingTransfer: 'orange',
  passportNeededList: 'purple',
  passportNeededDetail: 'geekblue',
} as const;

/**
 * SHAR-329/347 — an ad-hoc status tag (MGAV overdue / New seats booked) with a
 * remove confirmation. Both clicking the tag body AND clicking the close "×"
 * open the same confirmation pop-up (controlled `open` state).
 */
export function AdhocTag({
  color,
  icon,
  label,
  title,
  description,
  onRemove,
  loading,
}: {
  color: string;
  icon?: ReactNode;
  label: string;
  title: string;
  description: string;
  onRemove: () => void;
  loading?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Popconfirm
      open={open}
      onOpenChange={setOpen}
      title={title}
      description={description}
      okText="Remove"
      okButtonProps={{ loading }}
      onConfirm={() => {
        onRemove();
        setOpen(false);
      }}
      onCancel={() => setOpen(false)}
    >
      <Tag
        icon={icon}
        color={color}
        closable
        // The "×" must trigger the same pop-up, not remove the tag directly.
        onClose={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
        onClick={() => setOpen(true)}
        style={{ cursor: 'pointer', marginInlineEnd: 0 }}
      >
        {label}
      </Tag>
    </Popconfirm>
  );
}
